import React from "react";
import Spinner from "../common/Spinner";

const withLoading = (Component, spinnerProps) => ({ isLoading, ...otherProps }) => isLoading ? <Spinner {...spinnerProps} /> : <Component {...otherProps} />

export { withLoading }
